module.exports = __webpack_public_path__ + "img/Blumenwiese-1920.8913485a.jpg";